module.exports = __webpack_public_path__ + "static/media/Sales_2.ddd57caf.gif";